import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { School } from '@mui/icons-material';
import TeachingJobManagement from '../../components/SuperAdmin/TeachingJobManagement';

const TeachingJobsPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{
        mb: 4,
        background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        borderRadius: 2,
        p: 3,
        color: 'white'
      }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          <School sx={{ mr: 2, verticalAlign: 'middle', fontSize: 'inherit' }} />
          Teaching Jobs
        </Typography>
        <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 300 }}>
          Create and manage teaching positions with specific requirements for educators
        </Typography>
      </Box>

      {/* Teaching Job Management Component */}
      <TeachingJobManagement />
    </Container>
  );
};

export default TeachingJobsPage;
